import { APPROVAL_TYPES, COMMENT_ACTIVITY_TYPES, activityTypes } from '../constants/activityTypes';
import { isContentEditEvent, parseActivityComment, parseActivityTarget, parseActivityUpdateDetails, parseApprovalNote } from './parse';
import { HUBSPOT_ACTOR_TYPE, HUBSPOT_USER_TYPE_ID } from '../constants/filterOptions';
export function parseActivityResult(activityResult) {
  const {
    timestamp,
    activityType,
    activityDetails,
    activityActorType,
    activityActorId,
    activityTargetObjects,
    activityResultObject,
    objectKey: {
      objectTypeId,
      objectId
    },
    objectName,
    id
  } = activityResult;
  const userId = activityActorType !== HUBSPOT_ACTOR_TYPE ? activityActorId : HUBSPOT_USER_TYPE_ID;
  const {
    assetType: targetAssetType,
    assetId: targetAssetId,
    assetName: targetAssetName
  } = [activityTypes.ASSOCIATED, activityTypes.DISASSOCIATED, activityTypes.CLONED_FROM, activityTypes.CREATED_PART_OF_AB].includes(activityType) && activityTargetObjects && activityTargetObjects.length ? activityTargetObjects.map(parseActivityTarget)[0] : {
    assetType: undefined,
    assetId: undefined,
    assetName: undefined
  };
  const resultingAsset = activityResultObject ? parseActivityTarget(activityResultObject) : undefined;
  return {
    activityActorType,
    activityType,
    activityTimestamp: timestamp,
    userId,
    assetId: objectId,
    assetName: objectName,
    assetType: objectTypeId,
    folderId: undefined,
    // TODO: Fill up this value when it's supported by the backend
    folderName: undefined,
    // TODO: Fill up this value when it's supported by the backend
    targetAssetId,
    targetAssetName,
    targetAssetType,
    resultingAsset,
    targetUserOrTeamId: undefined,
    // TODO: Fill up this value when it's supported by the backend
    approvalNote: APPROVAL_TYPES.includes(activityType) ? parseApprovalNote(activityDetails) : undefined,
    comment: COMMENT_ACTIVITY_TYPES.includes(activityType) ? parseActivityComment(activityDetails) : undefined,
    activityUpdateDetails: parseActivityUpdateDetails({
      activityType,
      activityDetails
    }),
    id,
    isContentEditEvent: isContentEditEvent(activityDetails)
  };
}